import React from 'react';

const Star = () => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.5 11.1833L11.8283 14.3333L10.1717 9.24666L14.5 6.16666H9.19167L7.5 0.916656L5.80833 6.16666H0.5L4.82833 9.24666L3.17167 14.3333L7.5 11.1833Z"
        fill="#F3C41E"
      />
    </svg>
  );
};

export default Star;
